"use client";

import React, { useState } from 'react';
import { Offer, ProductData } from '@/services/dataTypes';
import { getFinalDiscountTag } from '@/constants/hooks';
import SimpleOfferModal from './SimpleOfferModal';
import Link from 'next/link';

interface Props {
    offer: Offer | ProductData;
    merchantHref: string;
    imageSrc: string;
    merchantImg?: string | null;
    domain: string;
    type: 'anchor' | 'button';
    buttonClass?: string;
    isDetail?: number;
    productDetailUrl?: string | null;
}

const OfferDetailsToggle = ({ offer, merchantHref, domain, type, buttonClass, imageSrc, isDetail, productDetailUrl, merchantImg }: Props) => {
    const [showModal, setShowModal] = useState(false);

    // Prevent parent Link click when clicking this button
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const originalPrice = offer?.original_price ? parseFloat(offer?.original_price) : 0;
    const salePrice = offer?.sale_price ? parseFloat(offer?.sale_price) : 0;
    const discountPercent =
        originalPrice > 0 && salePrice > 0
            ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
            : null;

    const finalDiscountTag = getFinalDiscountTag(
        offer?.offer_title || offer?.offer_detail,
        discountPercent,
    );

    const label = 'View Details';
    const sharedClass = `${type === 'anchor' ? 'offer-details-anchor' : 'offer-details-btn'} cursor-pointer ${buttonClass || ''}`;

    // If is_detail === 1 and we have a URL, navigate to the detail page
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link href={productDetailUrl} className="position-relative text-decoration-underline" style={{ color: '#666', zIndex: 5, transition: 'color 0.2s ease' }}>
                {label}
            </Link>
        );
    }

    // Otherwise, show modal as before
    return (
        <>
            {type === 'anchor' ? (
                <span onClick={handleClick} className={sharedClass}>
                    {label}
                </span>
            ) : (
                <button onClick={handleClick} className={sharedClass}>
                    {label}
                </button>
            )}

            {showModal && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setShowModal(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                    merchantImg={merchantImg ?? imageSrc}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
